export { SharedDataAccessCoreModule } from './lib/shared-data-access-core.module';
export { CoreFacade } from './lib/core.facade';
